import React, { useEffect, useState } from 'react';
import { Container, Content, EmptyDiv, Header, IconWrapper, NoteText, StyledButton } from './WithdrawPage.styles';
import { Text20Bold } from '../../components/utils/Text/Text.styles';
import { ReactComponent as ChevronLeftIcon } from '../../assets/icons/chevron_left.svg';
import { NumericInput } from '../../components';
import { useNavigate } from 'react-router-dom';
import { WALLET } from '../../components/App/routes';
import { useDispatch, useSelector } from 'react-redux';
import { selectWithdrawalActionsPending } from '../../store/slices/withdrawal/slice';
import { requestWithdrawal } from '../../store/slices/withdrawal/asyncThunks';
import { notifyError } from '../../utils/notify';
import { selectUser, selectUserActionsPending } from '../../store/slices/user/slice';
import { useConfirmationModal } from '../../components/modals/ConfirmationModal/ConfirmationModal';

const WithdrawPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  const { earnings } = user.analytics;
  const { requestWithdrawal: requestWithdrawalPending } = useSelector(selectWithdrawalActionsPending);
  const { uploadW9Form: uploadW9FormPending } = useSelector(selectUserActionsPending);
  // const [selectedMethodType, setSelectedMethodType] = useState(null);
  // const [selectedMethod, setSelectedMethod] = useState(null);
  const [amount, setAmount] = useState('');

  const [openModal, closeModal, setConfirmationModalLoader] = useConfirmationModal();

  useEffect(() => {
    if (earnings.available < 500 || user.thisMonthWithdrawals >= 2 || user.hasPendingWithdrawal) {
      navigate(`/${WALLET}`);
    }
  }, [user, earnings.available, navigate]);

  // const onMethodClick = type => {
  //   if (type === selectedMethodType) {
  //     setSelectedMethodType(null);
  //     setSelectedMethod(null);
  //   } else {
  //     setSelectedMethodType(type);
  //   }
  // };

  useEffect(() => {
    setConfirmationModalLoader(requestWithdrawalPending || uploadW9FormPending);
    // eslint-disable-next-line
  }, [requestWithdrawalPending, uploadW9FormPending]);

  const submitWithdrawalRequest = () => {
    openModal(
      'Request Withdrawal',
      `Are you sure you want to withdraw $${+amount}?`,
      'Confirm',
      () => {
        // if (
        //   selectedMethodType === WITHDRAWAL_METHOD_TYPE.DOMESTIC_WIRE &&
        //   selectedMethod.profileType === WITHDRAWAL_METHOD_PROFILE_TYPE.PERSONAL &&
        //   !user.w9Info.verified
        // ) {
        //   dispatch(uploadW9Form({ file: w9FormFile }))
        //     .unwrap()
        //     .then(() => {
        //       dispatch(
        //         requestWithdrawal({
        //           withdrawalMethodType: selectedMethodType,
        //           withdrawalMethodId: selectedMethod._id,
        //           amount: +amount,
        //         }),
        //       )
        //         .unwrap()
        //         .then(() => {
        //           closeModal();
        //           navigate(`/${WALLET}`);
        //         })
        //         .catch(err => {
        //           notifyError(err.message);
        //         });
        //     })
        //     .catch(err => {
        //       notifyError(err.message);
        //     });
        // } else {
        dispatch(
          requestWithdrawal({
            amount: +amount,
          }),
        )
          .unwrap()
          .then(() => {
            closeModal();
            navigate(`/${WALLET}`);
          })
          .catch(err => {
            notifyError(err.message);
          });
      },
      'Cancel',
      () => {
        closeModal();
      },
    );
  };

  // const onSubmitW9Form = e => {
  //   const file = e.target.files[0];
  //   setW9FormFile(file);
  // };

  return (
    <Container>
      <Content>
        <Header>
          <IconWrapper onClick={() => navigate(`/${WALLET}`)}>
            <ChevronLeftIcon />
          </IconWrapper>
          <Text20Bold>Withdraw Money</Text20Bold>
          <EmptyDiv />
        </Header>
        <NoteText>
          Your balance can be withdrawn 21 days after it’s earned. You can request up to two withdrawals every month.
        </NoteText>
        <NoteText>
          Payments take approximately 5–7 business days to be processed and credited to your MassPay account after they
          are requested.
        </NoteText>
        {/* <Text16Bold>Select Method</Text16Bold>
        <MethodsContainer>
          <WithdrawalMethod
            title="Domestic Wire"
            description="Withdraw to a US bank account."
            note="Arriving in 5-7 business days."
            type={WITHDRAWAL_METHOD_TYPE.DOMESTIC_WIRE}
            isSelected={selectedMethodType === WITHDRAWAL_METHOD_TYPE.DOMESTIC_WIRE}
            onClick={() => onMethodClick(WITHDRAWAL_METHOD_TYPE.DOMESTIC_WIRE)}
            selectedMethod={selectedMethod}
            setSelectedMethod={setSelectedMethod}
          />
          <WithdrawalMethod
            title="International Wire"
            description="Withdraw to an international (non US) bank account."
            note="Arriving in 5-7 business days."
            isSelected={selectedMethodType === WITHDRAWAL_METHOD_TYPE.INTERNATIONAL_WIRE}
            type={WITHDRAWAL_METHOD_TYPE.INTERNATIONAL_WIRE}
            onClick={() => onMethodClick(WITHDRAWAL_METHOD_TYPE.INTERNATIONAL_WIRE)}
            selectedMethod={selectedMethod}
            setSelectedMethod={setSelectedMethod}
          />
          <WithdrawalMethod
            title="Crypto"
            description="Withdraw in cryptocurrency."
            note="Arriving in 1-2 business days."
            isSelected={selectedMethodType === WITHDRAWAL_METHOD_TYPE.CRYPTO}
            type={WITHDRAWAL_METHOD_TYPE.CRYPTO}
            onClick={() => onMethodClick(WITHDRAWAL_METHOD_TYPE.CRYPTO)}
            selectedMethod={selectedMethod}
            setSelectedMethod={setSelectedMethod}
          />
        </MethodsContainer> */}
        {/* {selectedMethodType === WITHDRAWAL_METHOD_TYPE.DOMESTIC_WIRE &&
          selectedMethod?.profileType === WITHDRAWAL_METHOD_PROFILE_TYPE.PERSONAL &&
          !user.w9Info.verified && (
            <W9FormContainer>
              <Text14Regular>Fill the W-9 Form</Text14Regular>
              <W9FormDesc>Download, complete, and sign the W-9 form, then upload it as a PDF.</W9FormDesc>
              <DownloadFormButton onClick={() => window.open('https://www.irs.gov/pub/irs-pdf/fw9.pdf', '_blank')}>
                <Text14Regular>Get W-9 Form</Text14Regular>
                <DownloadIcon />
              </DownloadFormButton>
              <FileLabel htmlFor="fileUpload">
                {w9FormFile ? w9FormFile.name : 'Submit Signed W-9'}
                {w9FormFile && (
                  <CloseIcon
                    onClick={e => {
                      setW9FormFile(null);
                      fileInputRef.current.value = null;
                      e.preventDefault();
                    }}
                  />
                )}
              </FileLabel>
              <FileInput ref={fileInputRef} id="fileUpload" type="file" accept=".pdf" onChange={onSubmitW9Form} />
            </W9FormContainer>
          )} */}
        <NumericInput label="Amount" placeholder="Enter amount" onChange={e => setAmount(e.target.value)} />
        <StyledButton
          title="Submit"
          disabled={!amount.trim()}
          onClick={submitWithdrawalRequest}
          isLoading={requestWithdrawalPending || uploadW9FormPending}
        />
      </Content>
    </Container>
  );
};

export default WithdrawPage;
